// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"74ec1425","465":"9d113993","525":"43069467","648":"bb51cc81","682":"7dc5458e","686":"f9f9ccef","886":"343b8e9a"}[chunkId] + ".chunk.js";
};